export default {
  ORANGE: '#ffc72b',
  RED: '#EB0045',
  DARKBLUE: '#031e3b',
  BLUE: '#63C7A9',
  BLACK: '#343a3f',
  DARK: '#4d5256',
}
